export default async function getImageBlobFromUrl(svgUrl) {
  return await fetch(svgUrl).then(res => res.blob());
}
